import RealtimeMessages from '@fiverr-private/realtime_notifications/src/RealtimeNotifications';
import { get } from 'lodash';
import { DEFAULT_REALTIME_ENABLED, DEFAULT_SOUND_ENABLED } from '../../constants';

/**
 * @typedef {Object} RealtimeMessagesProps
 * @property {boolean} realtimeEnabled Should render notifications.
 * @property {boolean} soundEnabled Should play sounds.
 */

/**
 * Serializes the layout data into a format accepted by the realtime notifications package.
 * @param {User} options.user User data.
 * @return {RealtimeMessagesProps}
 */
export const serializer = ({ user }) => ({
    realtimeEnabled: get(user, 'settings.realtimeNotifications', DEFAULT_REALTIME_ENABLED),
    soundEnabled: get(user, 'settings.soundNotifications', DEFAULT_SOUND_ENABLED)
});

export default RealtimeMessages;
